import { render, staticRenderFns } from "./FooterComponentAmseu.vue?vue&type=template&id=21d7de8e"
import script from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"
export * from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports